import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, switchMap } from 'rxjs';
import { environment } from 'environments/environment';
import { GridService } from './grid.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient, private _gridService: GridService) { }

    // Scope APIs
    getScopes(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}Config/GetScopes`);
    }

    createScope(scope: any): Observable<any> {
        console.log("SCOPE: ", scope);
        return this.http.post<any>(`${this.apiUrl}Config/CreateScope`, scope);
    }

    createCommand(scope: any): Observable<any> {
        console.log("SCOPE: ", scope);
        return this.http.post<any>(`${this.apiUrl}Config/CreateCommand`, scope);
    }

    createComponent(scope: any): Observable<any> {
        console.log("SCOPE: ", scope);
        return this.http.post<any>(`${this.apiUrl}Config/CreateComponent`, scope);
    }

    createView(scope: any): Observable<any> {
        console.log("SCOPE: ", scope);
        return this.http.post<any>(`${this.apiUrl}Config/CreateView`, scope);
    }

    updateScope(scope: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}Config/UpdateScope`, scope);
    }

    deleteScope(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}Config/DeleteScope/${id}`);
    }

    deleteCommand(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}Config/DeleteCommand/${id}`);
    }

    updateCommand(command: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}Config/UpdateScopeCommand`, command);
    }


    // Field APIs
    getFields(scope: string): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}Config/GetScopeFields/${scope}`);
    }

    getAllFields(): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrl}Config/GetAllFields`);
    }

    createField(field: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}Config/CreateField`, field);
    }

    updateField(field: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}Config/UpdateField`, field);
    }

    deleteField(id: string): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}Config/DeleteField/${id}`);
    }

    //Folder APIs

    updateFolder(folder: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}Config/UpdateFolder`, folder);
    }

    // Linking APIs
    linkFieldToScope(scope: string, field: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}Config/LinkFieldToScope/${scope}/${field}`, {});
    }

    unlinkFieldFromScope(scope: string, field: string): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}Config/UnlinkFieldFromScope/${scope}/${field}`, {});
    }
    getBranding(id: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}Config/GetBranding/${id}`);
    }
    
    getLanguages(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}Accounts/GetLanguages/`);
    }
        
    getLanguageTranslations(lang): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}Accounts/GetLanguageTranslations/${lang}`);
    }

    //Views APIs

    getDrpData(actUrl: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}${actUrl}`);
    }

    getScopeView(code: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}View/GetScopeView/${code}`);
    }

    //Token APIs
    getAnonymousToken(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}Accounts/anonymous-token`);
    }



}
